const config = {
    appName: "ALPC",
    appNameForTitle: "ALPC by ALCOLM",
    footerTagLine1: "Alcolm AG Cloud Software",
    footerTagLine2: "Alcolm Logistics Platform for Carriers 1.5. Copyright © 2014 - 2024 Alcolm. All Rights Reserved."
}

export default config;
